import useAppStore from '@/store/useAppStore'
import useGetCashflowPeriods from '@/services/api/cash-flow/useGetCashflowPeriods'

/**
 * Opening / closing balance for one vault in one period, read straight off the
 * period-aggregate feed. Replaces the client-side running-balance reducer that
 * used to live in useGetVaultClosingBalanceByOffset.
 *
 * @param {{ vaultId?: number, offset?: number }} args
 * @returns {{ data: { opening_balance: number, closing_balance: number } | undefined, isLoading: boolean }}
 */
export default function useVaultBalanceForOffset({ vaultId, offset }) {
  const periodType = useAppStore((state) => state.periodType)
  const viewOffset = useAppStore((state) => state.offset)
  const numberOfPeriods = useAppStore((state) => state.numberOfPeriods)

  const { data: periods, isLoading } = useGetCashflowPeriods({
    offset: viewOffset,
    numberOfPeriods,
    periodType,
  })

  if (vaultId === undefined || offset === undefined) {
    return { data: undefined, isLoading }
  }

  const period = periods?.find((p) => Number(p.offset) === Number(offset))
  const vault = period?.vaults?.[vaultId]

  return {
    data: vault
      ? {
          opening_balance: vault.opening_balance,
          closing_balance: vault.closing_balance,
        }
      : undefined,
    isLoading,
  }
}
